import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";
import { getApiData } from "../../../../../helpers/AxiosInstance";
import APIS from "../../../../../constant/Endpoint";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  // const locationData = await getApiData(APIS.LOCATION, {});
  // if (!locationData || !locationData?.data) {
  //   console.error("Location data is not available!");
  //   return;
  // }
  // const options = locationData?.data
  //   ?.map((item: { id: string; name: string }) => {
  //     return `<li data-id="${item.id}" class="p-2 cursor-pointer hover:bg-gray-200">${item.name}</li> `;
  //   })
  //   .join("");

  Components.addType("checkout", {
    isComponent: (el) => {
      if (
        el.className &&
        typeof el.className === "string" &&
        el.className.includes("check-out")
      ) {
        return {
          type: "checkout",
        };
      }

      return false;
    },

    model: {
      defaults: {
        tagName: "main",
        classes: ["check-out"],
        components: /*html*/ `
            <section class="container mx-auto px-4 my-4">
              <form action=""  autocomplete="off" novalidate="novalidate">
                <div
                  class="grid grid-cols-1 md:grid-cols-4 gap-y-2 gap-x-6 mx-3 md:mx-0"
                >
                  <div
                    class="flex flex-col mb-6 gap-y-3 md:gap-y-4 md:col-span-2"
                  >
                    <div
                      class="flex items-center justify-start gap-x-2 mb-2 border-b border-black"
                    >
                      <div
                        class="border-s-4 border-[var(--primary)] h-8 relative -top-2"
                      ></div>
                      <h2
                        class="font-medium font-montserrat text-2xl md:text-3xl mb-5"
                      >
                        Contact Information
                      </h2>
                    </div>
                      <label>
                      <span class="text-sm text-gray-500">Email*</span>
                      <input
                        class="bg-[#EFF4F4] w-full py-2 px-2 mt-2 rounded-lg focus:outline-none"
                        placeholder="Email"
                        name="email"
                        id="email"
                      />
                      </label>
                    <div class="flex gap-x-2 items-center">
                      <input type="checkbox" class="w-4 h-4" />
                      <p>Keep me upto date on news and exclusive offers</p>
                    </div>
                    <div class="grid grid-cols-2 gap-x-6 ">
                      <label >
                        <span class="text-sm text-gray-500 ">Full Name*</span>
                        <input
                          class="bg-[#EFF4F4] w-full py-2 px-2 mt-2 rounded-lg focus:outline-none "
                          placeholder="Enter full name"
                          name="full_name"
                          id="full_name"
                        />
                      </label>
                      <label>
                        <span class="text-sm text-gray-500">Phone No.*</span>
                        <input
                          class="bg-[#EFF4F4] w-full py-2 px-2 mt-2 rounded-lg focus:outline-none"
                          placeholder="Enter phone number"
                          name="phone_number"
                          id="phone_number"
                        />
                      </label>
                    </div>
                    <div
                      class="flex items-center justify-start gap-x-2 mb-2 border-b border-black mt-2"
                    >
                      <div
                        class="border-s-4 border-[var(--primary)] h-8 relative -top-2"
                      ></div>
                      <h2
                        class="font-medium font-montserrat text-2xl md:text-3xl mb-5"
                      >
                        Shipping Address
                      </h2>
                    </div>
                    <label>
                      <span class="text-sm text-gray-500">Street Address*</span>
                      <input
                        class="bg-[#EFF4F4] w-full py-2 px-2 mt-2 rounded-lg focus:outline-none"
                        placeholder="Eg:Baneshwor"
                        name="street_address"
                        id="shipping_address"
                      />
                    </label>
                    <div class="grid grid-cols-2 gap-x-6 mt-4">

                      <div class="relative w-full">
                      <label class="text-sm text-gray-500" for="searchInput">City*</label>
                      <div class="relative">
            <input
                type="text"
                id="searchInput"
                placeholder="Search city..."
                class="bg-[#EFF4F4] w-full py-2 px-2 mt-2 rounded-lg focus:outline-none"
                autocomplete="off"
            />
            <div id="clearIcon" class=" absolute right-8  top-[60%] transform -translate-y-1/2 text-gray-500 cursor-pointer hidden">
            <svg width="24px" height="24px" viewBox="0 -0.5 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.96967 16.4697C6.67678 16.7626 6.67678 17.2374 6.96967 17.5303C7.26256 17.8232 7.73744 17.8232 8.03033 17.5303L6.96967 16.4697ZM13.0303 12.5303C13.3232 12.2374 13.3232 11.7626 13.0303 11.4697C12.7374 11.1768 12.2626 11.1768 11.9697 11.4697L13.0303 12.5303ZM11.9697 11.4697C11.6768 11.7626 11.6768 12.2374 11.9697 12.5303C12.2626 12.8232 12.7374 12.8232 13.0303 12.5303L11.9697 11.4697ZM18.0303 7.53033C18.3232 7.23744 18.3232 6.76256 18.0303 6.46967C17.7374 6.17678 17.2626 6.17678 16.9697 6.46967L18.0303 7.53033ZM13.0303 11.4697C12.7374 11.1768 12.2626 11.1768 11.9697 11.4697C11.6768 11.7626 11.6768 12.2374 11.9697 12.5303L13.0303 11.4697ZM16.9697 17.5303C17.2626 17.8232 17.7374 17.8232 18.0303 17.5303C18.3232 17.2374 18.3232 16.7626 18.0303 16.4697L16.9697 17.5303ZM11.9697 12.5303C12.2626 12.8232 12.7374 12.8232 13.0303 12.5303C13.3232 12.2374 13.3232 11.7626 13.0303 11.4697L11.9697 12.5303ZM8.03033 6.46967C7.73744 6.17678 7.26256 6.17678 6.96967 6.46967C6.67678 6.76256 6.67678 7.23744 6.96967 7.53033L8.03033 6.46967ZM8.03033 17.5303L13.0303 12.5303L11.9697 11.4697L6.96967 16.4697L8.03033 17.5303ZM13.0303 12.5303L18.0303 7.53033L16.9697 6.46967L11.9697 11.4697L13.0303 12.5303ZM11.9697 12.5303L16.9697 17.5303L18.0303 16.4697L13.0303 11.4697L11.9697 12.5303ZM13.0303 11.4697L8.03033 6.46967L6.96967 7.53033L11.9697 12.5303L13.0303 11.4697Z" fill="currentColor"/>
</svg>
            </div>
            <div class=" absolute right-2 top-[60%] transform -translate-y-1/2 text-gray-500">

            <svg fill="currentColor" height="16px" width="16px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
	 viewBox="0 0 330 330" xml:space="preserve">
<path id="XMLID_225_" d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393
	c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393
	s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"/>
</svg>
</div>
        </div>
                      <input type="hidden" id="city" name="city"/>

                      <ul id="dropdown" class="absolute w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg hidden max-h-40 overflow-y-auto">
                         tets
                      </ul>
                  </div>


                      <label>
                        <span class="text-sm text-gray-500">State</span>
                        <input
                          class="bg-[#EFF4F4] w-full py-2 px-2 mt-2 rounded-lg focus:outline-none"
                          placeholder="Eg:Bagmati"
                          name="state"
                          id="state"
                        />
                      </label>
                    </div>
                    <div>
                    <label class="flex gap-x-2 items-center">
                      <input
                        type="checkbox"
                        class="w-4 h-4"
                        id="terms-conditions"
                        name="terms-conditions"
                      />
                      <div class="text-gray-500 mt-1" >
                        <span class="text-black">I accept</span>
                        <a href="/terms-conditions" class="ml-1"
                          >Terms and Conditions</a
                        >
                      </div>
                    </label>
                    </div>
                  </div>
                  <div class="flex flex-col gap-y-4">
                    <div
                      class="flex items-center justify-start gap-x-2 mb-2 border-b border-black"
                    >
                      <div
                        class="border-s-4 border-[var(--primary)] h-8 relative -top-2"
                      ></div>
                      <h2
                        class="font-medium font-montserrat text-2xl md:text-3xl mb-5 uppercase"
                      >
                        Shipping Method
                      </h2>
                    </div>
                    <div class="flex flex-col gap-y-4">
                      <!-- {% shipping_methods as shipping_methods_dict %} -->
                      <!-- {% for shipping_method in shipping_methods_dict.shipping_methods %} -->
                      <div class="flex justify-between items-center">
                        <div class="flex gap-x-2 items-center">
                          <!-- {% comment %} -->

                          <input
                            type="radio"
                            name="shipping_method"
                            id="standard"
                            value="100"
                            data-charge="100"
                            class="w-4 h-4 "
                            checked
                          />
                          <!-- {% endcomment %} -->

                          <!-- <input
                            type="radio"
                            id="{{ shipping_method.id }}"
                            value="{{ shipping_method.id }}"
                            data-charge="{{ shipping_method.charge }}"
                            name="shipping_method"
                            class="w-4 h-4"
                            {% if forloop.first %} checked {% endif %}
                          > -->

                          <!-- {% comment %} -->
                          <label for="standard"
                            >Standard &#40;14 days&#41;</label
                          >
                          <!-- {% endcomment %} -->
                          <!-- <label for="{{ shipping_method.id }}">{{ shipping_method.name|capfirst }} ({{ shipping_method.note }})</label> -->
                        </div>
                        <p class="font-semibold">
                          <!-- {% comment %} -->
                          Rs.100
                          <!-- {% endcomment %} -->
                          <!-- {{ shipping_method.charge }} -->
                        </p>
                      </div>
                      <!-- {% endfor %} -->

                      <!-- {% comment %} -->

                      <div class="flex justify-between items-center">
                        <div class="flex gap-x-2 items-center">
                          <input
                            type="radio"
                            class="w-4 h-4"
                            value="200"
                            data-charge="200"
                            id="express"
                            name="shipping_method"
                          />
                          <label for="express">Express &#40;10 days&#41;</label>
                        </div>
                        <p class="font-semibold">Rs.200</p>
                      </div>
                      <div class="flex justify-between items-center">
                        <div class="flex gap-x-2 items-center">
                          <input
                            type="radio"
                            class="w-4 h-4 "
                            value="300"
                            data-charge="300"
                            id="same_day"
                            name="shipping_method"
                          />
                          <label for="same_day"
                            >Same Day &#40;24 Hrs&#41;</label
                          >
                        </div>
                        <p class="font-semibold">Rs.300</p>
                      </div>
                      <!-- {% endcomment %} -->
                    </div>

                    <div
                      class="flex items-center justify-start gap-x-2 mb-2 border-b border-black"
                    >
                      <div
                        class="border-s-4 border-[var(--primary)] h-8 relative -top-2"
                      ></div>
                      <h2
                        class="font-medium font-montserrat text-2xl md:text-3xl mb-5 uppercase"
                      >
                        Payment Method
                      </h2>
                    </div>
                    <div class="flex flex-col gap-y-4">
                      <!-- {% payment_methods as payment_methods_dict %} -->
                      <!-- {% for payment_method in payment_methods_dict.payment_methods %} -->
                      <div class="flex items-center gap-x-2">
                        <!-- {% comment %} -->
                        <input
                          type="radio"
                          class="w-4 h-4 "
                          name="payment_method"
                          data-slug="{{ payment_method.slug }}"
                          id="cash-on-delivery"
                          checked
                        />
                        <!-- {% endcomment %} -->

                        <!-- <input
                          type="radio"
                          class="w-4 h-4 "
                          name="payment_method"
                          id="{{ payment_method.id }}"
                          data-slug="{{ payment_method.slug }}"
                          value="{{ payment_method.id }}"
                          ={% if forloop.first %} checked {% endif %}
                        /> -->
                        <!-- {% comment %} -->

                        <label for="cash-on-delivery">Cash On Delivery</label>
                        <!-- {% endcomment %} -->

                        <!-- <label for="{{ payment_method.id }}">{{ payment_method.name }}</label> -->
                      </div>
                      <!-- {% comment %} -->

                      <div class="flex items-center gap-x-2">
                        <input
                          type="radio"
                          class="w-4 h-4 "
                          id="qr_payment"
                          name="payment_method"
                        />
                        <label for="qr_payment">QR Payment</label>
                      </div>
                      <!-- {% endcomment %} -->
                      <!-- {% endfor %} -->
                    </div>
                  </div>
                  <div class="bg-[#F5F5F5] p-4 rounded-lg">
                    <div class="flex items-center justify-start gap-x-2">
                      <div
                        class="border-s-4 border-[var(--primary)] h-8 relative -top-2"
                      ></div>
                      <h2
                        class="font-medium font-montserrat text-2xl md:text-3xl mb-5"
                      >
                        Summary
                      </h2>
                    </div>
                    <div class="flex flex-col gap-y-2">
                        <!-- {% cart_items as products_list %}
                        {% for item_dict in products_list.cart_item_list %} -->
                          <div class="flex justify-between items-center">
                            <div>
                      <!-- {% comment %} -->
                            shirt
                      <!-- {% endcomment %} -->
                             <!-- {{ item_dict.product.name }} -->
                             </div>
                            <div class="whitespace-nowrap"> x
                            <!-- {% comment %} -->
                            3
                            <!-- {% endcomment %} -->
                            <!-- {{ item_dict.quantity }} -->
                            </div>
                          </div>
                          <!-- {% if not forloop.last %} -->
                            <div class="w-full border border-b border-gray-300"></div>
                            <!-- {% endif %}
                        {% endfor %} -->
                      </div>

                      <div class="py-6 border-black mt-4 border-t border-b">
                        <div class="flex justify-between items-center">
                          <p>Total</p>
                            <!-- {% comment %} -->
                          <p class="font-semibold" id="total-amount" data-total-amount="3000">
                          Rs.3000
                          </p>
                           <!-- {% endcomment %} -->
                           <!--
                           <p class="font-semibold" id="total-amount" data-total-amount="{{ products_list.sum_total }}">
                           Rs.{{ products_list.sum_total }}
                            </p> -->
                        </div>
                        <div class="flex justify-between items-center">
                          <p>Delivery Cost</p>
                          <p id="delivery-charge" class="font-semibold">Rs.{{ delivery_charge }}</p>
                        </div>
                      </div>
                      <div class="flex flex-col justify-center items-center gap-y-3 mt-4">
                        <div class="flex justify-between items-center w-full">
                          <p class="text-lg font-semibold">Grand Total</p>
                          <p id="grand-total" class="font-semibold">
                            Rs.{{ grand_total }}
                          </p>
                        </div>
                      </div>

                      <div
                        class="w-full flex flex-col gap-y-6 justify-center items-center h-60 px-4"
                      >
                          <div class="w-full control-wrapper">
                            <button
                              type="submit"
                              id="order-now-btn"
                              class="bg-[var(--primary)] text-white w-full text-center py-2 rounded-lg focus:outline-none uppercase relative overflow-hidden ripple-effect button cursor-pointer "
                            >
                             <span id="order-now-text"> Order Now </span>
                              <div
                              role="status"
                              id="spinner"
                              class="spinner hidden flex justify-center"
                            >
                              <svg
                                aria-hidden="true"
                                class="h-6 w-6 text-gray-200 animate-spin dark:text-gray-600 fill-[var(--primary)]"
                                viewBox="0 0 100 101"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                  fill="currentColor"
                                />
                                <path
                                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                  fill="currentFill"
                                />
                              </svg>
                            </div>
                            </button>
                          </div>
                        <a href="/cart" class="w-full border border-[var(--primary)] text-[var(--primary)] w-full text-center py-2 rounded-lg focus:outline-none uppercase uppercase relative overflow-hidden ripple-effect button cursor-pointer">
                            Return To Cart
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </section>

        `,
        script: function () {
          const checkoutForm = document.querySelector(
            ".check-out form"
          ) as HTMLFormElement;
          const spinner = document.querySelector("#spinner");
          const orderNowText = document.querySelector("#order-now-text");
          const cartElement = document.getElementById("cart-count");
          const orderNowBtn = document.querySelector(
            "#order-now-btn"
          ) as HTMLButtonElement;

          function getCheckedPaymentMethod() {
            const checkedRadio = document.querySelector(
              'input[name="payment_method"]:checked'
            );
            return checkedRadio ? checkedRadio.getAttribute("data-slug") : null;
          }

          if (!checkoutForm) return;
          const phoneInput = document.querySelector(
            "#phone_number"
          ) as HTMLInputElement;
          phoneInput.addEventListener("input", () => {
            if (!phoneInput.value.startsWith("+977")) {
              phoneInput.value =
                "+977" + phoneInput.value.replace(/[^0-9]/g, "");
            }
          });
          let validator;
          const initLib = function () {
            //@ts-ignore
            validator = new JustValidate(checkoutForm);
            validator
              .addField(document.querySelector("#email"), [
                {
                  rule: "required",
                  errorMessage: "Email is required",
                },
                {
                  rule: "email",
                  errorMessage: "Invalid email",
                },
              ])
              .addField(document.querySelector("#full_name"), [
                {
                  rule: "required",
                  errorMessage: "Full name is required",
                },
              ])
              .addField(document.querySelector("#phone_number"), [
                {
                  rule: "required",
                  errorMessage: "Phone number is required",
                },
                {
                  rule: "custom",
                  validator: (value) => /^\+977\d{9,10}$/.test(value),
                  errorMessage: "Enter a valid phone number",
                },
              ])
              .addField(document.querySelector("#shipping_address"), [
                {
                  rule: "required",
                  errorMessage: "Street address is required",
                },
              ])
              .addField(document.querySelector("#city"), [
                {
                  rule: "required",
                  errorMessage: "City is required",
                },
              ])
              .addField(document.querySelector("#terms-conditions"), [
                {
                  rule: "required",
                  errorMessage:
                    "Please accept terms and conditions to continue",
                },
              ]);
          };
          const urlParams = new URLSearchParams(window.location.search);
          const productSlug = urlParams.get("product_slug");
          const quantity = urlParams.get("quantity");
          let toastify;
          const handleSubmit = function () {
            const formData = new FormData(checkoutForm);
            fetch(
              `{% url 'order_checkout' %}?slug=${productSlug ?? ""}&quantity=${
                quantity ?? ""
              }`,
              {
                method: "POST",
                body: formData,
              }
            )
              .then(function (response) {
                return response.json().then((data) => {
                  if (!response.ok) {
                    throw data;
                  }
                  return data;
                });
              })
              .then(function (result) {
                checkoutForm.reset();
                toastify.showToast();
                cartElement.textContent = "0";
                window.location.href = `/order-detail`;
              })
              .catch(function (errors) {
                console.error("Error submitting checkout:", errors);
                if (
                  errors?.message &&
                  Object.prototype.toString.call(errors.message) ===
                    "[object Object]"
                ) {
                  Object.keys(errors.message).forEach((field) => {
                    const fieldSelector = `#${field}`;
                    const fieldElement = document.querySelector(fieldSelector);
                    if (!fieldElement) {
                      console.warn(`Field not found: ${fieldSelector}`);
                      return;
                    }
                    const errorObj = {};
                    errorObj[fieldSelector] = errors.message[field][0];
                    validator.showErrors(errorObj);
                  });
                }
              })
              .finally(() => {
                orderNowText.classList.remove("hidden");
                spinner.classList.add("hidden");
                orderNowBtn.disabled = false;
              });
          };

          const openMoadal = function () {
            //@ts-ignore
            Swal.fire({
              title: "<h3>Qr Payment</h3>",
              html: `
                <form
                  id="popup-modal-content"
                  class="bg-white rounded-lg shadow-lg p-6 w-full max-w-md mx-auto"
                >
                  <div class="mx-auto w-[250px] h-[250px] mb-4">
                    <img
                      src="{% qr_image %}"
                      alt="qr_name"
                      class="w-full h-full object-contain"
                    />
                  </div>

                  <p class="text-center mb-4">
                    {{ payment_method.options.details }}
                  </p>

                  <div class="mb-4">
                    <label
                      for="image-upload"
                      class="block text-sm font-medium mb-1"
                    >
                      Payment Screenshot:
                    </label>
                    <input
                      type="file"
                      id="image-upload"
                      name="image"
                      accept="image/*"
                      class="w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    />
                    <p
                      id="error-message"
                      class="text-[var(--primary)] text-sm text-center mt-2 hidden"
                    ></p>
                  </div>
                  <div class="space-y-2">
                    <button
                      type="button"
                      id="pay-button"
                      class="w-full bg-red-400 text-white py-2 rounded-md hover:bg-primary-500 transition duration-200"
                    >
                      <span id="pay-now-text">Pay Now </span>
                      <div
                        role="status"
                        id="modal-spinner"
                        class=" hidden flex justify-center"
                      >
                        <svg
                          aria-hidden="true"
                          class="h-6 w-6 text-gray-200 animate-spin dark:text-gray-600 fill-[var(--primary)]"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill"
                          />
                        </svg>
                      </div>
                    </button>
                  </div>
                </form>
              `,
              showConfirmButton: false,
              showCloseButton: true,
              showCancelButton: false,
              focusConfirm: false,
              didOpen: () => {
                const payButton = document.getElementById(
                  "pay-button"
                ) as HTMLButtonElement;
                const payNowText = document.getElementById(
                  "pay-now-text"
                ) as HTMLElement;
                const spinner = document.getElementById(
                  "modal-spinner"
                ) as HTMLElement;
                payButton.addEventListener("click", function () {
                  const fileInput = document.getElementById(
                    "image-upload"
                  ) as HTMLInputElement;
                  const file = fileInput.files[0];

                  if (!file) {
                    document.getElementById("error-message").textContent =
                      "Please upload a payment screenshot.";
                    document
                      .getElementById("error-message")
                      .classList.remove("hidden");
                    return;
                  }
                  const formData = new FormData(checkoutForm);
                  formData.append("image", file);
                  payButton.disabled = true;
                  payNowText.classList.add("hidden");
                  spinner.classList.remove("hidden");

                  fetch(
                    `{% url 'order_checkout' %}?slug=${
                      productSlug ?? ""
                    }&quantity=${quantity ?? ""}`,
                    {
                      method: "POST",
                      body: formData,
                    }
                  )
                    .then((response) => response.json())
                    .then((result) => {
                      //@ts-ignore
                      Swal.close();
                      checkoutForm.reset();
                      toastify.showToast();
                      cartElement.textContent = "0";
                      window.location.href = `/order-detail`;
                    })
                    .catch((error) => console.error("Error:", error))
                    .finally(() => {
                      payNowText.classList.remove("hidden");
                      spinner.classList.add("hidden");
                      payButton.disabled = false;
                    });
                });
              },
            });
          };

          const searchInput = document.getElementById(
            "searchInput"
          ) as HTMLInputElement;
          const cityIdInput = document.getElementById(
            "city"
          ) as HTMLInputElement;
          const dropdown = document.getElementById("dropdown") as HTMLElement;
          const listItems = dropdown.getElementsByTagName("li");
          const clearIcon = document.getElementById("clearIcon");

          // Show dropdown when input is clicked
          searchInput.addEventListener("focus", (event) => {
            dropdown.classList.remove("hidden");
            event.stopPropagation();
          });

          // Filter options when typing
          searchInput.addEventListener("input", () => {
            const searchText = searchInput.value.toLowerCase();
            Array.from(listItems).forEach((li) => {
              const text = li.textContent.toLowerCase();
              li.style.display = text.includes(searchText) ? "block" : "none";
            });
          });

          Array.from(listItems).forEach((li) => {
            li.addEventListener("click", (event) => {
              searchInput.value = li.textContent;
              cityIdInput.value = li.getAttribute("data-id");
              dropdown.classList.add("hidden");
              clearIcon.classList.remove("hidden");
              event.stopPropagation();
            });
          });

          document.addEventListener("click", (event) => {
            if (!(event.target as HTMLElement).closest(".relative")) {
              dropdown.classList.add("hidden");
              if (!cityIdInput.value) {
                searchInput.value = "";
                const searchText = searchInput.value.toLowerCase();
                Array.from(listItems).forEach((li) => {
                  const text = li.textContent.toLowerCase();
                  li.style.display = text.includes(searchText)
                    ? "block"
                    : "none";
                });
                clearIcon.classList.add("hidden");
              }
            }
          });

          clearIcon.addEventListener("click", () => {
            searchInput.value = "";
            cityIdInput.value = "";
            dropdown.classList.add("hidden");
            clearIcon.classList.add("hidden");
          });

          const initToastLib = function () {
            //@ts-ignore
            toastify = Toastify({
              text: "Order booked successfully",
              duration: 2000,
              // destination: "/",
              // newWindow: false,
              close: false,
              gravity: "top",
              position: "right",
              stopOnFocus: true,
              offset: {
                x: 20,
                y: 60,
              },
            });
          };

          checkoutForm.addEventListener("submit", function (event) {
            event.preventDefault();
            const selectedPaymentSlug = getCheckedPaymentMethod();

            validator.onSuccess((isValid) => {
              if (!isValid) {
                console.log("Form validation failed.");
                return;
              }
              if (selectedPaymentSlug === "qr-payment") {
                openMoadal();
                return;
              }

              // const formObject = {};

              // formData.forEach(function (value, key) {
              //   formObject[key] = value;
              // });
              orderNowBtn.disabled = true;
              orderNowText.classList.add("hidden");
              spinner.classList.remove("hidden");
              handleSubmit();
            });
          });
          const shippingInputs = document.querySelectorAll(
            'input[name="shipping_method"]'
          );

          const deliveryChargeElement =
            document.getElementById("delivery-charge");
          const grandTotalElement = document.getElementById("grand-total");
          const totalAmountElement = document.getElementById("total-amount");
          let totalAmount =
            totalAmountElement.getAttribute("data-total-amount");

          function updateTotals() {
            const selectedMethod = document.querySelector(
              'input[name="shipping_method"]:checked'
            ) as HTMLInputElement;
            let deliveryCharge = selectedMethod
              ? parseFloat(selectedMethod.dataset.charge)
              : 0;
            let grandTotal = Number(totalAmount) + deliveryCharge;
            deliveryChargeElement.textContent = `Rs.${deliveryCharge}`;
            grandTotalElement.textContent = `Rs.${grandTotal}`;
          }

          shippingInputs.forEach((input) => {
            input.addEventListener("change", updateTotals);
          });
          updateTotals();

          //@ts-ignore
          if (typeof Toastify === "undefined") {
            const script = document.createElement("script");
            script.onload = initToastLib;
            script.src = "https://cdn.jsdelivr.net/npm/toastify-js";
            document.body.appendChild(script);
          } else {
            initToastLib();
          }

          //@ts-ignore
          if (typeof JustValidate === "undefined") {
            const script = document.createElement("script");
            script.onload = initLib;
            script.src =
              "https://unpkg.com/just-validate@latest/dist/just-validate.production.min.js";
            document.body.appendChild(script);
          } else {
            initLib();
          }
        },
      },
    },
  });
};
